import React, { useState, useEffect } from "react";
import "./ClientManager.css"; // Arquivo de estilização
import Conect from "../../../../../Api/Conect";
// import { useNavigate } from "react-router-dom";
import moment from "moment";

// Estado inicial do formulário
const initialFormState = {
  id: "",
  name: "",
  cpf: "",
  cnpj: "",
  phone_number: "",
  state_cod: "",
};

const ClientManager = () => {
  // const history = useNavigate();
  const token = localStorage.getItem("restoken");
  const [clients, setClients] = useState([]);
  const [states, setStates] = useState([]);
  const [form, setForm] = useState(initialFormState);
  const [editing, setEditing] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Busca lista de clientes ao montar o componente
  useEffect(() => {
    fetchClients();
    // eslint-disable-next-line
  }, []);

  // Função para buscar os clientes e seus estados
  const fetchClients = async () => {
    try {
      const { data: clientsData } = await Conect.get(`/Y29zdHVtZXJzbGlzdA==${token}`);
      const { data: stateData } = await Conect.get(`/bGlzdHN0YXRlcw==${token}`);
      const mergedData = mergeClientsWithState(clientsData.data, stateData.data);
      setClients(mergedData);
      setStates(stateData.data)
      console.log(mergedData)
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    }
  };

  // Função para combinar as informações de cliente com os estados
  const mergeClientsWithState = (clients, states) => {
    return clients.map((client) => ({
      ...client,
      state: states.find((st) => st.id === client.state_cod)?.prefix || "Desconhecido",
      fuso_cli: states.find((st) => st.id === client.state_cod)?.fuso || "Desconhecido",
    }));
  };

  // Função para lidar com a mudança de input do formulário
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
  };

  // Função para enviar os dados de criação ou edição de cliente
  const handleSubmit = async () => {
    try {
      editing
        ? await Conect.put("/Y29zdHVtZXJzdXBkYXRl", form) // Rota para atualizar cliente
        : await Conect.post("/Y29zdHVtZXJzY3JlYXQ=", form); // Rota para criar cliente
      fetchClients();
      closeModal();
    } catch (error) {
      console.error(`Erro ao ${editing ? "atualizar" : "criar"} cliente:`, error);
    }
  };

  // Função para excluir um cliente
  const handleDeleteClient = async (id) => {
    try {
      await Conect.delete("/ZGVsZXRlY29zdHVtZXJz", { data: { id } }); // Rota para deletar cliente
      fetchClients();
    } catch (error) {
      console.error("Erro ao remover cliente:", error);
    }
  };

  // Função para abrir o modal com dados do cliente (se houver) para edição ou vazio para criação
  const openModal = (client = null) => {
    setForm(client ? client : initialFormState);
    setEditing(!!client);
    setShowModal(true);
  };

  // Função para fechar o modal
  const closeModal = () => setShowModal(false);

  return (
    <div className="client-manager">
      <h2>Gerenciamento de Clientes</h2>
      <button className="client-btns-block" onClick={() => openModal()}>Adicionar Cliente</button>

      <table className="client-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th>CPF/CNPJ</th>
            <th>Telefone</th>
            <th>Cidade</th>
            <th>Estado</th>
            <th>Fuso</th>
            <th>Atualizado</th>
            <th>Criado</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {clients.map((client) => (
            <tr key={client.id}>
              <td>{client.id}</td>
              <td>{client.name}</td>
              <td>{client.cpf || client.cnpj}</td>
              <td>{client.phone_number}</td>
              <td>{client.city}</td>
              <td>{client.state}</td>
              <td>{client.fuso_cli}</td>
              <td>{client.updated_at ? moment(client.updated_at).format("DD/MM/YYYY HH:mm:ss") : "--"}</td>
              <td>{moment(client.created_at).format("DD/MM/YYYY HH:mm:ss")}</td>
              <td>
                <button className="client-btns-block" style={{ marginRight: 4 }} onClick={() => openModal(client)}>Editar</button>
                <button className="client-btns-block" onClick={() => handleDeleteClient(client.id)}>Remover</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      {showModal && (
        <div className="client-modal">
          <div className="client-modal-content">
            <h3>{editing ? "Editar Cliente" : "Adicionar Cliente"}</h3>
            <input
              type="text"
              name="name"
              placeholder="Nome"
              value={form.name}
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="cpf"
              placeholder="CPF"
              value={form.cpf}
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="cnpj"
              placeholder="CNPJ"
              value={form.cnpj}
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="phone_number"
              placeholder="Telefone"
              value={form.phone_number}
              onChange={handleInputChange}
            />
            <select
              name="state_cod"
              value={form.state_cod}
              onChange={handleInputChange}
            >
              {states.map((option) => (
                <option key={option.id} value={option.id}>
                  {`${option.description} (${option.fuso})`}
                </option>
              ))}
            </select>
            <div className="client-modal-actions">
              <button className="client-btns-block" onClick={handleSubmit}>{editing ? "Atualizar" : "Adicionar"} Cliente</button>
              <button className="client-btns-block" onClick={closeModal}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientManager;
